module.exports = __webpack_public_path__ + "img/1.dd70e1f9.png";